@if (membershipError) {
  <p role="alert">{{ membershipError }} <button mat-button (click)="loadCert()">Erneut laden</button></p>
}
<app-con-x-table-page
  eyebrow="Construct-X"
  eyebrowIcon="account_balance_wallet"
  title="Wallet"
  description="Zertifizierungen und Construct-X Mitgliedschaft durchsuchen, prüfen und verwalten."
  ariaLabel="Wallet-Einträge"
  locale="de-DE"
  [data]="certificates"
  [columns]="columns"
  [rowActions]="rowActions"
  [inspector]="inspector"
  [rowId]="certificateId"
  [selectedRow]="selectedCertificate"
  [summaryItems]="summaryItems"
  [emptyState]="emptyState"
  [loading]="loading"
  loadingMessage="Zertifikate werden geladen …"
  [errorMessage]="errorMessage"
  errorTitle="Wallet nicht erreichbar"
  retryLabel="Erneut laden"
  searchPlaceholder="Name, Aussteller oder Status suchen"
  noResultsTitle="Keine passenden Zertifikate"
  noResultsDescription="Ändern Sie den Suchbegriff."
  [refreshable]="true"
  (refreshRequested)="loadCert()"
  (retryRequested)="loadCert()"
  [pageSize]="10"
  [pageSizeOptions]="[10, 25, 50]"
  (selectedRowChange)="selectCertificate($event)"
  (rowAction)="handleRowAction($event)">
</app-con-x-table-page>

<ng-template #vcDialog>
  <section class="vc-dialog" aria-labelledby="vc-dialog-title">
    <header class="vc-dialog-header">
      <div>
        <span>Verifiable Credential</span>
        <h2 id="vc-dialog-title">{{ vcCertificate?.getName() }}</h2>
      </div>
      <button mat-icon-button mat-dialog-close type="button" aria-label="VC-Inhalt schließen">
        <mat-icon>close</mat-icon>
      </button>
    </header>

    <mat-dialog-content class="vc-dialog-content">
      @if (vcCertificate) {
        <app-cert-details
          [detailType]="viewMode.get(vcCertificate.getId())"
          [isAuth]="isAuth"
          [vcTreeData]="vcTreeData.get(vcCertificate.getId())"
          [certificate]="vcCertificate">
        </app-cert-details>
      }
    </mat-dialog-content>
  </section>
</ng-template>
